(function () {
  // All add-on/basic-product/cam-upgrade/cam-option data now comes from the
  // shared window.JRJ_TUNE_BUILDER_DRAFT.homepage object (via window.JRJ_TUNE_CART),
  // the same single source of truth the homepage Guided Tune Builder and the
  // product-page tune builder (buy-buttons.liquid) use -- this file used to
  // keep its own hardcoded copy of all of it, which could silently drift out
  // of sync with the other builders.
  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function unique(values) {
    return values.filter(Boolean).filter(function (value, index, arr) {
      return arr.indexOf(value) === index;
    }).sort();
  }

  function setOptions(select, values, placeholder) {
    var current = select.value;
    select.innerHTML = '<option value="">' + placeholder + '</option>' + values.map(function (value) {
      return '<option value="' + escapeHtml(value) + '">' + escapeHtml(value) + '</option>';
    }).join('');
    if (values.indexOf(current) !== -1) select.value = current;
    select.disabled = !values.length;
  }

  function parseConfig(root) {
    var node = root.querySelector('[data-jrj-mini-config]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.error('JRJ Unified Builder: invalid configuration JSON.', error);
      return null;
    }
  }

  function setBuilderStartupFailure(root, error) {
    if (!root) return;
    root.dataset.jrjMiniReady = 'error';
    delete root.dataset.jrjMiniInitializing;
    var cartButton = root.querySelector('[data-jrj-mini-cart]');
    var status = root.querySelector('[data-jrj-mini-startup-status]');
    if (cartButton) {
      cartButton.disabled = true;
      cartButton.setAttribute('aria-disabled', 'true');
      cartButton.setAttribute('data-jrj-mini-startup-disabled', '');
    }
    if (status) {
      status.hidden = false;
      status.classList.add('is-error');
      status.textContent = 'The vehicle configurator could not start. Refresh this page or call or text JRJ at 910-239-7598.';
    }
    if (error) console.error('JRJ Unified Builder: initialization failed.', error);
  }

  function setBuilderStartupReady(root) {
    root.dataset.jrjMiniReady = 'true';
    delete root.dataset.jrjMiniInitializing;
    var cartButton = root.querySelector('[data-jrj-mini-cart]');
    var status = root.querySelector('[data-jrj-mini-startup-status]');
    if (cartButton) cartButton.removeAttribute('data-jrj-mini-startup-disabled');
    if (status) {
      status.classList.remove('is-error');
      status.hidden = true;
    }
  }

  function allYears(builderMap) {
    var years = [];
    (builderMap.groups || []).forEach(function (group) {
      var ranges = String(group.years || '').match(/\d{4}(?:\s*-\s*(?:\d{4}|Present))?/g) || [];
      ranges.forEach(function (range) {
        var parts = range.split('-').map(function (part) { return part.trim(); });
        var start = parseInt(parts[0], 10);
        var end = parts[1] === 'Present' ? new Date().getFullYear() : parseInt(parts[1] || parts[0], 10);
        for (var year = start; year <= end; year++) years.push(year);
      });
    });
    return unique(years).sort(function (a, b) { return b - a; });
  }

  function vehicleProductVariantFromUrl(productConfig, search) {
    if (!vehicleProductConfigMatchesFamily(productConfig) || !Array.isArray(productConfig.variants) || !Array.isArray(productConfig.optionNames)) return null;
    var ids = new URLSearchParams(search || '').getAll('variant');
    if (ids.length !== 1 || !/^\d+$/.test(ids[0])) return null;
    var optionNames = productConfig.optionNames;
    var yearIndex = optionNames.indexOf('Year');
    var typeIndex = optionNames.indexOf('Tune Type');
    if (optionNames.length !== 2 || yearIndex === -1 || typeIndex === -1) return null;
    var matches = productConfig.variants.filter(function (variant) { return String(variant.id) === ids[0]; });
    if (matches.length !== 1 || !Array.isArray(matches[0].options) || matches[0].options.length !== 2) return null;
    var year = String(matches[0].options[yearIndex]);
    var service = matches[0].options[typeIndex];
    var fixedVehicle = productConfig.fixedVehicle;
    var type = service === productConfig.tuneTypeValues.custom ? 'custom' : (service === productConfig.tuneTypeValues.base ? 'base' : '');
    if (!/^\d{4}$/.test(year) || Number(year) < Number(fixedVehicle.yearStart) || Number(year) > Number(fixedVehicle.yearEnd) || !type) return null;
    return { year: year, tuneType: type };
  }

  function vehicleProductConfigMatchesFamily(productConfig) {
    var config = productConfig || {};
    var gen3Engines = ['5.3L LM7', '5.3L L59', '5.3L L33'];
    var gen4Engines = ['5.3L LH6', '5.3L LY5', '5.3L LC9', '5.3L LMG'];
    var families = {
      '2014-2018-chevrolet-silverado-1500-5-3l-l83-tuning': { make: 'Chevrolet', model: 'Silverado 1500', groupId: 'gen5_gm_truck_suv', yearStart: 2014, yearEnd: 2018, engine: '5.3L L83' },
      '2014-2018-gmc-sierra-1500-5-3l-l83-tuning': { make: 'GMC', model: 'Sierra 1500', groupId: 'gen5_gm_truck_suv', yearStart: 2014, yearEnd: 2018, engine: '5.3L L83' },
      '2003-2006-chevrolet-silverado-1500-5-3l-tuning': { make: 'Chevrolet', model: 'Silverado', groupId: 'gen3_gm_truck_suv', yearStart: 2003, yearEnd: 2006, allowedEngines: gen3Engines },
      '2003-2006-gmc-sierra-1500-5-3l-tuning': { make: 'GMC', model: 'Sierra', groupId: 'gen3_gm_truck_suv', yearStart: 2003, yearEnd: 2006, allowedEngines: gen3Engines },
      '2007-2013-chevrolet-silverado-1500-5-3l-tuning': { make: 'Chevrolet', model: 'Silverado 1500', groupId: 'gen4_gm_truck_suv', yearStart: 2007, yearEnd: 2013, allowedEngines: gen4Engines },
      '2007-2013-gmc-sierra-1500-5-3l-tuning': { make: 'GMC', model: 'Sierra 1500', groupId: 'gen4_gm_truck_suv', yearStart: 2007, yearEnd: 2013, allowedEngines: gen4Engines },
      '2009-2014-ram-1500-5-7l-hemi-tuning': { make: 'RAM', model: 'Ram 1500', groupId: 'hemi_ram_2009_2012', yearStart: 2009, yearEnd: 2014, engine: '5.7L Eagle HEMI', groupRanges: [
        { yearStart: 2009, yearEnd: 2012, groupId: 'hemi_ram_2009_2012' },
        { yearStart: 2013, yearEnd: 2014, groupId: 'hemi_ram_2013_2018' }
      ] },
      '2015-2018-ram-1500-5-7l-hemi-tuning': { make: 'RAM', model: 'Ram 1500', groupId: 'hemi_ram_2013_2018', yearStart: 2015, yearEnd: 2018, engine: '5.7L Eagle HEMI' }
    };
    var family = Object.prototype.hasOwnProperty.call(families, config.handle) ? families[config.handle] : null;
    var vehicle = config.fixedVehicle || {};
    var tuneTypes = config.tuneTypeValues || {};
    if (config.enabled !== true || !family || vehicle.make !== family.make || vehicle.model !== family.model ||
        vehicle.groupId !== family.groupId || Number(vehicle.yearStart) !== family.yearStart || Number(vehicle.yearEnd) !== family.yearEnd ||
        tuneTypes.custom !== 'Full Custom Remote Tune' || tuneTypes.base !== 'Base Tune — One Revision') return false;
    var ranges = vehicle.groupRanges;
    if (family.groupRanges) {
      if (!Array.isArray(ranges) || ranges.length !== family.groupRanges.length || !family.groupRanges.every(function (expected, index) {
        var actual = ranges[index];
        return actual && Number(actual.yearStart) === expected.yearStart && Number(actual.yearEnd) === expected.yearEnd && actual.groupId === expected.groupId;
      })) return false;
    } else if (ranges && (!Array.isArray(ranges) || ranges.length)) return false;
    if (family.allowedEngines) {
      var allowed = vehicle.allowedEngines;
      return vehicle.variableEngine === true && vehicle.engine === '' && Array.isArray(allowed) && allowed.length === family.allowedEngines.length &&
        family.allowedEngines.every(function (engine) { return allowed.indexOf(engine) !== -1; });
    }
    return vehicle.engine === family.engine && vehicle.variableEngine !== true &&
      (!vehicle.allowedEngines || (Array.isArray(vehicle.allowedEngines) && vehicle.allowedEngines.length === 0));
  }

  function initBuilder(root) {
    if (!root || root.dataset.jrjMiniReady === 'true' || root.dataset.jrjMiniInitializing === 'true') return;
    root.dataset.jrjMiniInitializing = 'true';

    var builderMap = window.JRJ_TUNE_BUILDER_DRAFT || { groups: [], baseProducts: {}, addons: {}, addonRules: {}, includedDeletes: [] };
    var config = parseConfig(root);

    function startingPriceLabel(service) {
      var price = config.startingPrices && config.startingPrices[service];
      if (!price || price.available !== true || price.currency !== window.JRJ_TUNE_CART.activeCurrency() ||
          !Number.isFinite(Number(price.priceCents)) || Number(price.priceCents) <= 0) return 'Price Unavailable';
      return price.label || window.JRJ_TUNE_CART.formatPrice(price.priceCents);
    }

    if (!config || !window.JRJ_TUNE_CART || !window.JRJ_TUNE_BUILDER_DRAFT || !window.JRJ_CUSTOM_CAM_SPECS || typeof window.JRJ_CUSTOM_CAM_SPECS.create !== 'function') {
      setBuilderStartupFailure(root);
      return;
    }
    var vehicleProductConfig = config.vehicleProduct || {};
    var vehicleProductMode = vehicleProductConfig.enabled === true;
    var serviceOnlyMode = vehicleProductMode || config.serviceOnly === true;
    var remoteProductKey = !vehicleProductMode && serviceOnlyMode && config.remoteProduct
      ? window.JRJ_TUNE_CART.findBaseProductKeyByHandle(config.remoteProduct.handle) : null;
    var remoteCandidateGroups = remoteProductKey ? (builderMap.groups || []).filter(function (group) {
      return group.baseProductKey === remoteProductKey || (group.engineRules || []).some(function (rule) {
        return window.JRJ_TUNE_CART.baseProductKeyForEngine(group, rule.engine) === remoteProductKey;
      });
    }) : [];
    var remoteYearRows = {};
    if ((root.hasAttribute('data-jrj-vehicle-product-mode') && !vehicleProductMode) ||
        (vehicleProductMode && !vehicleProductConfigMatchesFamily(vehicleProductConfig))) {
      setBuilderStartupFailure(root);
      return;
    }
    var fixedVehicle = vehicleProductConfig.fixedVehicle || {};
    var yearEl = root.querySelector('[data-jrj-mini-year]');
    var makeEl = root.querySelector('[data-jrj-mini-make]');
    var modelEl = root.querySelector('[data-jrj-mini-model]');
    var engineEl = root.querySelector('[data-jrj-mini-engine]');
    var camEl = root.querySelector('[data-jrj-mini-cam]');
    var transmissionEl = root.querySelector('[data-jrj-mini-transmission]');
    var drivetrainEl = root.querySelector('[data-jrj-mini-drivetrain]');
    var boostInputs = Array.prototype.slice.call(root.querySelectorAll('[data-jrj-mini-boost]'));
    var typeEl = root.querySelector('[data-jrj-mini-type]');
    var typeCards = Array.prototype.slice.call(root.querySelectorAll('[data-jrj-mini-type-card]'));
    var platformEl = root.querySelector('[data-jrj-mini-platform]');
    var addonWrap = root.querySelector('[data-jrj-mini-addons]');
    var modOptionsWrap = root.querySelector('[data-jrj-mini-mod-options]');
    var downloadLimitWrap = root.querySelector('[data-jrj-mini-download-limit]');
    var downloadCheckingWrap = root.querySelector('[data-jrj-mini-download-checking]');
    var downloadCheckingTitle = root.querySelector('[data-jrj-mini-download-checking-title]');
    var downloadCheckingCopy = root.querySelector('[data-jrj-mini-download-checking-copy]');
    var downloadFoundWrap = root.querySelector('[data-jrj-mini-download-found]');
    var downloadFoundTitle = root.querySelector('[data-jrj-mini-download-found-title]');
    var downloadMissingWrap = root.querySelector('[data-jrj-mini-download-missing]');
    var downloadFallbackButtons = Array.prototype.slice.call(root.querySelectorAll('[data-jrj-mini-fallback-path]'));
    var modLabelEl = root.querySelector('[data-jrj-mini-mod-label]');
    var resultEl = root.querySelector('[data-jrj-mini-result]');
    var textBtn = root.querySelector('[data-jrj-mini-text]');
    var cartBtn = root.querySelector('[data-jrj-mini-cart]');
    var mpvi4CheckEl = root.querySelector('[data-jrj-mpvi4-check]');
    var mpvi4Upsell = root.querySelector('[data-jrj-mpvi4-upsell]');
    var mpvi4StatusEl = root.querySelector('[data-jrj-mpvi4-status]');
    var rushTurnaroundEl = addonWrap && addonWrap.querySelector('input[value="Rush Turnaround"]');
    var MPVI4_VARIANT_ID = 43599565652035;
    var MPVI4_PRICE_CENTS = 41999;
    var mpvi4AlreadyInCart = false;
    var priceLookupToken = 0;
    var customPriceLookupToken = 0;
    var vehicleServicePriceKey = '';
    var genericServicePriceKey = '';
    var summaryPriceReady = false;
    var summaryTotalCents = 0;
    var customCamController = null;
    var downloadMatchState = 'idle';
    var downloadMatchKey = '';
    var vehicleVariantError = '';
    var vehicleMatrixError = null;
    var vehicleBusyStates = null;
    var cartRequestPending = false;
    var restoreAfterCartRequest = false;

    if (!yearEl || !makeEl || !modelEl || !engineEl || !camEl || !transmissionEl || !drivetrainEl || boostInputs.length !== 2 || !typeEl || !platformEl || !addonWrap || !resultEl || !cartBtn) {
      setBuilderStartupFailure(root);
      return;
    }

    function setSummaryValue(name, value) {
      var node = root.querySelector('[data-jrj-mini-summary="' + name + '"]');
      if (node) node.textContent = value;
    }

    function initializeVehicleProductVariantFromUrl() {
      if (!vehicleProductMode) return false;
      var selection = vehicleProductVariantFromUrl(vehicleProductConfig, window.location && window.location.search);
      if (!selection) return false;
      yearEl.value = selection.year;
      typeEl.value = selection.tuneType;
      camEl.value = '';
      transmissionEl.value = '';
      drivetrainEl.value = '';
      // Reuse the normal year handler for engine choices, service prices, and
      // purchase gates. The bubbling event also updates the vehicle gallery.
      yearEl.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    function fixedVehicleYears() {
      var start = parseInt(fixedVehicle.yearStart, 10);
      var end = parseInt(fixedVehicle.yearEnd, 10);
      var years = [];
      if (!isFinite(start) || !isFinite(end) || start > end) return years;
      for (var year = end; year >= start; year -= 1) years.push(String(year));
      return years;
    }

    function remoteVehicleRows(year) {
      if (!remoteProductKey) return [];
      if (remoteYearRows[year]) return remoteYearRows[year];
      var rows = [];
      var seen = {};
      remoteCandidateGroups.forEach(function (group) {
        Object.keys(group.makes || {}).forEach(function (make) {
          group.makes[make].forEach(function (model) {
            window.JRJ_TUNE_CART.vehicleSelectionMatches(year, make, model, '').forEach(function (row) {
              var key = [row.make, row.model, row.engine].join('|');
              if (row.baseProductKey !== remoteProductKey || seen[key]) return;
              seen[key] = true;
              rows.push(row);
            });
          });
        });
      });
      remoteYearRows[year] = rows;
      return rows;
    }

    function selectedVehicleGroupId() {
      var ranges = fixedVehicle.groupRanges;
      if (!Array.isArray(ranges) || !ranges.length) return String(fixedVehicle.groupId || '');
      var year = Number(yearEl.value);
      var matches = ranges.filter(function (range) { return year >= Number(range.yearStart) && year <= Number(range.yearEnd); });
      return matches.length === 1 ? String(matches[0].groupId || '') : '';
    }

    function variableVehicleEngineOptions() {
      if (!vehicleProductMode || fixedVehicle.variableEngine !== true || fixedVehicleYears().indexOf(String(yearEl.value)) === -1) return [];
      var year = Number(yearEl.value);
      var allowed = fixedVehicle.allowedEngines || [];
      return window.JRJ_TUNE_CART.vehicleEngines(yearEl.value, fixedVehicle.make, fixedVehicle.model).filter(function (engine) {
        return allowed.indexOf(engine) !== -1 && (engine !== '5.3L L33' || year >= 2005);
      });
    }

    function applyFixedVehicleSelection() {
      if (!vehicleProductMode) return;
      var controls = [
        [makeEl, fixedVehicle.make, 'Vehicle make'],
        [modelEl, fixedVehicle.model, 'Vehicle model']
      ];
      if (fixedVehicle.variableEngine !== true) controls.push([engineEl, fixedVehicle.engine, 'Vehicle engine']);
      controls.forEach(function (entry) {
        setOptions(entry[0], entry[1] ? [String(entry[1])] : [], entry[2]);
        entry[0].value = String(entry[1] || '');
        entry[0].disabled = true;
        entry[0].setAttribute('aria-readonly', 'true');
      });
      if (fixedVehicle.variableEngine === true) {
        setOptions(engineEl, variableVehicleEngineOptions(), 'Select engine...');
        engineEl.removeAttribute('aria-readonly');
      }
    }

    function fixedVehicleSelectionMatches() {
      if (!vehicleProductMode) return true;
      var year = parseInt(yearEl.value, 10);
      var start = parseInt(fixedVehicle.yearStart, 10);
      var end = parseInt(fixedVehicle.yearEnd, 10);
      if (!isFinite(year) || year < start || year > end) return false;
      if (String(makeEl.value) !== String(fixedVehicle.make || '')) return false;
      if (String(modelEl.value) !== String(fixedVehicle.model || '')) return false;
      if (fixedVehicle.variableEngine === true) {
        if (variableVehicleEngineOptions().indexOf(String(engineEl.value)) === -1) return false;
        if (fixedVehicle.groupId === 'gen3_gm_truck_suv') {
          if (transmissionEl.value !== '4L60E') return false;
          var allowedDrivetrains = engineEl.value === '5.3L L33' ? ['4WD / 4x4'] : ['RWD / 4x2', '4WD / 4x4'];
          if (allowedDrivetrains.indexOf(drivetrainEl.value) === -1) return false;
        }
      } else if (String(engineEl.value) !== String(fixedVehicle.engine || '')) return false;
      var selectedGroup = findSelectedGroup(engineEl.value);
      return !!(selectedGroup && String(selectedGroup.id || '') === selectedVehicleGroupId());
    }

    function validateVehicleProductMatrix() {
      if (!vehicleProductMode) return '';
      if (vehicleMatrixError !== null) return vehicleMatrixError;
      var years = fixedVehicleYears();
      var tuneTypeValues = vehicleProductConfig.tuneTypeValues || {};
      var typeKeys = ['custom', 'base'];
      var variants = Array.isArray(vehicleProductConfig.variants) ? vehicleProductConfig.variants : [];
      var seenVariantIds = {};
      vehicleMatrixError = '';

      if (!years.length || variants.length !== years.length * typeKeys.length) {
        vehicleMatrixError = 'This vehicle product must have exactly ' + (years.length * typeKeys.length) + ' Year and Tune Type variants.';
        return vehicleMatrixError;
      }

      for (var yearIndex = 0; yearIndex < years.length; yearIndex += 1) {
        for (var typeIndex = 0; typeIndex < typeKeys.length; typeIndex += 1) {
          var typeValue = tuneTypeValues[typeKeys[typeIndex]];
          var resolution = window.JRJ_TUNE_CART.resolveConfiguredVariantByOptions(vehicleProductConfig, {
            Year: years[yearIndex],
            'Tune Type': typeValue
          });
          if (!resolution || !resolution.ok || !resolution.item) {
            vehicleMatrixError = resolution && resolution.error ? resolution.error : 'The required vehicle variant matrix is incomplete.';
            return vehicleMatrixError;
          }
          var variantKey = String(resolution.item.variantId);
          if (seenVariantIds[variantKey]) {
            vehicleMatrixError = 'Each vehicle year and tune type must have its own unique Shopify variant.';
            return vehicleMatrixError;
          }
          seenVariantIds[variantKey] = true;
        }
      }
      return vehicleMatrixError;
    }

    function resolveVehicleProductVariant() {
      vehicleVariantError = '';
      if (!vehicleProductMode || (typeEl.value !== 'custom' && typeEl.value !== 'base')) return null;
      var matrixError = validateVehicleProductMatrix();
      if (matrixError) {
        vehicleVariantError = matrixError;
        return null;
      }
      if (fixedVehicle.variableEngine === true && (transmissionEl.value === "Not Listed / Don't Know" || drivetrainEl.value === "Not Listed / Don't Know")) {
        vehicleVariantError = 'Contact JRJ before ordering so we can verify your transmission and drivetrain.';
        return null;
      }
      if (!fixedVehicleSelectionMatches()) {
        vehicleVariantError = 'The selected vehicle no longer matches this vehicle-specific product.';
        return null;
      }
      var tuneTypeValue = vehicleProductConfig.tuneTypeValues && vehicleProductConfig.tuneTypeValues[typeEl.value];
      var resolution = window.JRJ_TUNE_CART.resolveConfiguredVariantByOptions(vehicleProductConfig, {
        Year: String(yearEl.value),
        'Tune Type': tuneTypeValue
      });
      if (!resolution || !resolution.ok || !resolution.item) {
        vehicleVariantError = resolution && resolution.error ? resolution.error : 'The exact vehicle variant is not configured.';
        return null;
      }
      resolution.item.handle = vehicleProductConfig.handle;
      resolution.item.vehicleProductVariant = true;
      try {
        return resolveVehicleProductServiceItem(typeEl.value, customCamController ? customCamController.canonicalCam() : camEl.value, resolution.item);
      } catch (error) {
        vehicleVariantError = error.message;
        return null;
      }
    }

    function vehicleProductSelectionFingerprint(base) {
      return JSON.stringify({
        year: yearEl.value,
        make: makeEl.value,
        model: modelEl.value,
        engine: engineEl.value,
        cam: customCamController ? customCamController.canonicalCam() : camEl.value,
        transmission: transmissionEl.value,
        drivetrain: drivetrainEl.value,
        tuneType: typeEl.value,
        addOns: getAddOns().slice().sort(),
        boost: getSelectedBoost(),
        mpvi4: !!(mpvi4CheckEl && mpvi4CheckEl.checked),
        primary: base ? String(base.variantId || base.handle || '') : ''
      });
    }

    function setVehicleProductControlsBusy(busy) {
      if (!vehicleProductMode) return;
      if (busy) {
        if (vehicleBusyStates) return;
        vehicleBusyStates = Array.prototype.slice.call(root.querySelectorAll('input, select, textarea, button')).map(function (control) {
          var state = { control: control, disabled: control.disabled };
          control.disabled = true;
          return state;
        });
        return;
      }
      (vehicleBusyStates || []).forEach(function (state) {
        state.control.disabled = state.disabled;
      });
      vehicleBusyStates = null;
    }

    function updateCartAvailability(base) {
      if (cartBtn.getAttribute('aria-busy') === 'true') return;
      var complete = !!(base && yearEl.value && makeEl.value && modelEl.value && engineEl.value && camEl.value && transmissionEl.value && drivetrainEl.value && (!customCamController || customCamController.isComplete()) && typeEl.value && summaryPriceReady);
      cartBtn.disabled = !complete || !downloadMatchReady();
      cartBtn.classList.toggle('is-disabled', cartBtn.disabled);
      cartBtn.setAttribute('aria-disabled', String(cartBtn.disabled));
    }

    function renderBuildConfirmation(base) {
      var boostName = getSelectedBoost();
      var properties = window.JRJ_TUNE_CART.buildPortalPurchaseProperties({
        year: yearEl.value,
        make: makeEl.value,
        model: modelEl.value,
        engine: engineEl.value,
        transmission: transmissionEl.value,
        drivetrain: drivetrainEl.value,
        cam: customCamController ? customCamController.canonicalCam() : camEl.value,
        tuneType: selectedTuneTypeLabel(base),
        mods: getAddOns(),
        lsaBlower: boostName === 'LSA Blower',
        hellcatBlower: boostName === 'Hellcat Blower',
        downloadable: typeEl.value === 'download'
      });
      setSummaryValue('vehicle', [properties.Year, properties.Make, properties.Model].filter(Boolean).join(' ') || 'Not selected');
      setSummaryValue('engine', properties.Engine || 'Not selected');
      setSummaryValue('transmission', properties.Transmission + ' / ' + properties.Drivetrain);
      setSummaryValue('cam', properties.Cam || 'Not selected');
      setSummaryValue('tune-type', properties['Tune Type'] || 'Not selected');
      setSummaryValue('mods', properties.Mods);
      setSummaryValue('blowers', 'LSA: ' + properties['LSA Blower'] + '; Hellcat: ' + properties['Hellcat Blower']);
      setSummaryValue('total', summaryPriceReady ? (window.JRJ_TUNE_CART.formatPrice(summaryTotalCents) || 'Price unavailable') : (base ? 'Loading...' : 'Select vehicle'));
      updateCartAvailability(base);
    }

    function downloadMatchReady() {
      return typeEl.value !== 'download' || downloadMatchState === 'found';
    }

    function downloadableSelectionReady() {
      return !!(yearEl.value && makeEl.value && modelEl.value && engineEl.value && camEl.value && transmissionEl.value && drivetrainEl.value && typeEl.value === 'download' && (!customCamController || customCamController.isComplete()));
    }

    function setDownloadMatchState(nextState, base) {
      downloadMatchState = nextState;
      if (downloadCheckingWrap) downloadCheckingWrap.hidden = nextState !== 'checking' && nextState !== 'incomplete';
      if (downloadFoundWrap) downloadFoundWrap.hidden = nextState !== 'found';
      if (downloadMissingWrap) downloadMissingWrap.hidden = nextState !== 'missing';
      if (downloadFoundTitle && base) downloadFoundTitle.textContent = base.title || 'Verified downloadable .HPT file';
      if (downloadCheckingTitle) {
        downloadCheckingTitle.textContent = nextState === 'checking'
          ? 'Verifying the exact product in Shopify...'
          : 'Complete the vehicle and camshaft selections.';
      }
      if (downloadCheckingCopy) {
        downloadCheckingCopy.textContent = nextState === 'checking'
          ? 'Please wait while Shopify confirms that the exact product is available for sale.'
          : 'Complete the selections so the builder can verify an exact downloadable product in Shopify.';
      }
      updateDownloadCartButtonText();
    }

    function updateDownloadCartButtonText() {
      if (!isDownloadPath()) return;
      if (downloadMatchState === 'found') {
        cartBtn.textContent = 'View File & Confirm 7 Requirements';
      } else if (downloadMatchState === 'missing') {
        cartBtn.textContent = 'Choose Base or Full Custom Tune Above';
      } else if (downloadMatchState === 'checking') {
        cartBtn.textContent = 'Checking Exact File Availability...';
      } else {
        cartBtn.textContent = 'Complete Selections To Check Availability';
      }
    }

    function beginDownloadAvailabilityCheck(base) {
      if (!isDownloadPath()) {
        downloadMatchKey = '';
        setDownloadMatchState('idle');
        return;
      }
      if (!downloadableSelectionReady()) {
        downloadMatchKey = '';
        setDownloadMatchState('incomplete');
        return;
      }
      if (!base || !base.exactDownload) {
        downloadMatchKey = '';

        setDownloadMatchState('missing');
        return;
      }
      var nextKey = String(base.handle || base.variantId || base.title || '');
      if (nextKey !== downloadMatchKey) {
        downloadMatchKey = nextKey;

        setDownloadMatchState('checking', base);
      } else if (downloadMatchState !== 'found') {
        setDownloadMatchState('checking', base);
      } else {
        setDownloadMatchState('found', base);
      }
    }

    function markDownloadMatchFound(base, token) {
      if (token !== priceLookupToken || !isDownloadPath() || !base || String(base.handle || base.variantId || base.title || '') !== downloadMatchKey) return;
      setDownloadMatchState('found', base);
    }

    function markDownloadMatchUnavailable(base, token) {
      if (token !== priceLookupToken || !isDownloadPath() || !base || String(base.handle || base.variantId || base.title || '') !== downloadMatchKey) return;

      setDownloadMatchState('missing');
      var copy = resultEl.querySelector('.jrj-mini-tune-builder__result-copy');
      if (copy) copy.innerHTML = '<strong>Tune path:</strong> Downloadable .HPT — Compare &amp; Copy<br>We could not verify this exact file as available for sale. Choose Base Tune or Full Custom Tune below.';
    }

    function findSelectedGroup(engine) {
      var selection = window.JRJ_TUNE_CART.resolveVehicleSelection(yearEl.value, makeEl.value, modelEl.value, engine);
      return selection && !selection.ambiguous && (!remoteProductKey || selection.baseProductKey === remoteProductKey) ? selection.group : null;
    }

    function customPriceCandidateGroups() {
      if (!yearEl.value || !makeEl.value || !modelEl.value) return remoteCandidateGroups.slice();
      if (engineEl.value) {
        var selected = findSelectedGroup(engineEl.value);
        return selected ? [selected] : [];
      }
      var groups = [];
      var seen = {};
      window.JRJ_TUNE_CART.vehicleSelectionMatches(yearEl.value, makeEl.value, modelEl.value, '').forEach(function (selection) {
        if (remoteProductKey && selection.baseProductKey !== remoteProductKey) return;
        var group = selection.group;
        var key = String((group && (group.id || group.baseProductKey)) || '');
        if (!group || !key || seen[key]) return;
        seen[key] = true;
        groups.push(group);
      });
      return groups;
    }

    function customPriceAmount(range) {
      if (!range || !range.minCents) return 'Loading...';
      if (range.minCents === range.maxCents) return window.JRJ_TUNE_CART.formatPrice(range.minCents);
      return window.JRJ_TUNE_CART.formatPrice(range.minCents) + '-' + window.JRJ_TUNE_CART.formatPrice(range.maxCents);
    }

    function applyCustomPriceRange(range) {
      var amount = customPriceAmount(range);
      var option = typeEl.querySelector('option[value="custom"]');
      if (!option) return;
      option.textContent = range && range.minCents !== range.maxCents
        ? 'Custom Remote - ' + amount + ' (engine/platform dependent)'
        : 'Custom Remote - Starting at ' + amount;
      if (serviceOnlyMode) setGenericServicePrice('custom', 'Full Custom Remote Tune', amount, false);
    }

    function vehicleProductBasicSelection(typeKey, camValue) {
      if (!vehicleProductMode || typeKey !== 'custom' || fixedVehicle.variableEngine === true ||
          fixedVehicle.groupId !== 'gen5_gm_truck_suv' || engineEl.value !== '5.3L L83' ||
          makeEl.value !== fixedVehicle.make || modelEl.value !== fixedVehicle.model ||
          fixedVehicleYears().indexOf(String(yearEl.value)) === -1 ||
          ['2014-2018-chevrolet-silverado-1500-5-3l-l83-tuning', '2014-2018-gmc-sierra-1500-5-3l-l83-tuning'].indexOf(vehicleProductConfig.handle) === -1) return '';
      if (camValue === 'Stock Cam / Delete Tune Only') return 'dod_afm';
      if (camValue === 'VVT Delete Only') return 'vvt';
      return '';
    }

    function resolveVehicleProductServiceItem(typeKey, camValue, nativeItem) {
      if (!vehicleProductBasicSelection(typeKey, camValue)) return nativeItem;
      var group = findSelectedGroup(engineEl.value);
      var mapped = window.JRJ_TUNE_CART.resolveMatchedBaseProductForGroup(group, engineEl.value, camValue, null);
      var variantId = Number(mapped && mapped.variantId);
      if (!group || group.id !== fixedVehicle.groupId || !mapped || !Number.isSafeInteger(variantId) || variantId <= 0 ||
          !window.JRJ_TUNE_CART.isBasicDeleteProduct(mapped)) {
        throw new Error('The selected basic tune product is unavailable. Please contact JRJ.');
      }
      return { variantId: variantId, title: mapped.title, strictVariant: true, vehicleBasicVariant: true };
    }

    function vehicleProductServiceLabels(typeKey) {
      var cam = customCamController ? customCamController.canonicalCam() : camEl.value;
      var basic = vehicleProductBasicSelection(typeKey, cam);
      var copy = vehicleProductConfig.serviceCopy || config.serviceCopy || {};
      if (!vehicleProductMode && typeKey === 'custom' && cam) {
        var group = findSelectedGroup(engineEl.value);
        var mapped = window.JRJ_TUNE_CART.resolveMatchedBaseProductForGroup(group, engineEl.value, cam, getBaseProduct());
        var support = window.JRJ_TUNE_CART.basicDeleteSupportLabel(mapped);
        if (support === 'DOD / AFM') basic = 'dod_afm';
        else if (support === 'VVT') basic = 'vvt';
        else if (support === 'MDS') return {title: mapped.title, eyebrow: copy.basic_eyebrow || 'Basic tune', description: copy.mds_description || '', button: copy.basic_button || ''};
      }
      var prefix = basic || typeKey;
      return { title: copy[prefix + '_title'] || '', eyebrow: copy[basic ? 'basic_eyebrow' : typeKey + '_eyebrow'] || '',
        description: copy[prefix + '_description'] || '', button: copy[basic ? 'basic_button' : 'custom_button'] || '' };
    }

    function validateVehicleBasicPrice(item, resolved) {
      if (item && item.vehicleBasicVariant && (!resolved || Number(resolved.id) !== Number(item.variantId) ||
          !isFinite(Number(resolved.priceCents)) || Number(resolved.priceCents) <= 0 || !resolved.variant ||
          resolved.variant.available === false || resolved.variant.requires_shipping === true)) {
        throw new Error('The selected basic tune price is unavailable. Please try again.');
      }
      return resolved;
    }

    function vehicleProductTuneTypePriceRange(typeKey) {
      var tuneTypeValue = vehicleProductConfig.tuneTypeValues && vehicleProductConfig.tuneTypeValues[typeKey];
      if (!tuneTypeValue) return null;
      var years = yearEl.value ? [String(yearEl.value)] : fixedVehicleYears();
      var prices = years.map(function (year) {
        var resolution = window.JRJ_TUNE_CART.resolveConfiguredVariantByOptions(vehicleProductConfig, {
          Year: year,
          'Tune Type': tuneTypeValue
        });
        return resolution && resolution.ok ? Number(resolution.item.priceCents) : 0;
      }).filter(function (price) { return isFinite(price) && price > 0; });
      if (!prices.length) return null;
      return {
        minCents: Math.min.apply(Math, prices),
        maxCents: Math.max.apply(Math, prices)
      };
    }

    function setVehicleProductTuneTypePrice(typeKey, amount, busy) {
      var option = typeEl.querySelector('option[value="' + typeKey + '"]');
      var prefix = typeKey === 'custom' ? 'Full Custom Remote' : 'Base Tune — One Revision';
      if (vehicleProductMode) prefix = vehicleProductServiceLabels(typeKey).title || prefix;
      if (option) option.textContent = prefix + ' — ' + amount;
      typeCards.forEach(function (card) {
        if (card.getAttribute('data-jrj-mini-type-card') !== typeKey) return;
        var price = card.querySelector('b');
        if (!price) return;
        price.setAttribute('aria-live', 'polite');
        price.setAttribute('aria-busy', String(!!busy));
        price.textContent = amount;
      });
    }

    function applyVehicleProductTuneTypePrices() {
      if (!vehicleProductMode) return;
      var year = String(yearEl.value);
      var engine = String(engineEl.value);
      var cam = customCamController ? customCamController.canonicalCam() : camEl.value;
      var camComplete = !customCamController || customCamController.isComplete();
      var key = JSON.stringify([year, makeEl.value, modelEl.value, engine, cam, camComplete]);
      if (key === vehicleServicePriceKey) return;
      vehicleServicePriceKey = key;
      var token = ++customPriceLookupToken;
      var group = engine ? findSelectedGroup(engine) : null;
      var canPriceCam = year && engine && cam && camComplete && group && group.id === selectedVehicleGroupId() &&
        makeEl.value === fixedVehicle.make && modelEl.value === fixedVehicle.model &&
        (fixedVehicle.variableEngine === true ? variableVehicleEngineOptions().indexOf(engine) !== -1 : engine === fixedVehicle.engine);
      var matrixError = validateVehicleProductMatrix();
      var camPrices = {};
      return Promise.all(['custom', 'base'].map(function (typeKey) {
        var range = vehicleProductTuneTypePriceRange(typeKey);
        setVehicleProductTuneTypePrice(typeKey, !matrixError && range ? customPriceAmount(range) : 'Price Unavailable', false);
        if (matrixError || !range || !canPriceCam) return;
        var resolution = window.JRJ_TUNE_CART.resolveConfiguredVariantByOptions(vehicleProductConfig, {
          Year: year,
          'Tune Type': vehicleProductConfig.tuneTypeValues[typeKey]
        });
        if (!resolution || !resolution.ok || !resolution.item) {
          setVehicleProductTuneTypePrice(typeKey, 'Price Unavailable', false);
          return;
        }
        var base;
        try {
          base = resolveVehicleProductServiceItem(typeKey, cam, resolution.item);
        } catch (error) {
          setVehicleProductTuneTypePrice(typeKey, 'Price Unavailable', false);
          return;
        }
        var camUpgrade = window.JRJ_TUNE_CART.resolveCamUpgradeForGroup(group, engine, cam, base, year, makeEl.value);
        var camKey = camUpgrade ? JSON.stringify(camUpgrade) : '';
        if (camUpgrade && !camPrices[camKey]) camPrices[camKey] = window.JRJ_TUNE_CART.resolvePricedItem(camUpgrade, engine);
        setVehicleProductTuneTypePrice(typeKey, 'Loading...', true);
        return Promise.all([
          window.JRJ_TUNE_CART.resolvePricedItem(base, engine),
          camUpgrade ? camPrices[camKey] : Promise.resolve(null)
        ]).then(function (parts) {
          if (token !== customPriceLookupToken) return;
          var baseResolved = validateVehicleBasicPrice(base, parts[0]);
          var camResolved = parts[1];
          var baseCents = genericServicePartCents(base, baseResolved);
          var camCents = camUpgrade ? genericServicePartCents(camUpgrade, camResolved) : 0;
          setVehicleProductTuneTypePrice(typeKey, window.JRJ_TUNE_CART.formatPrice(baseCents + camCents), false);
        }).catch(function () {
          if (token !== customPriceLookupToken) return;
          vehicleServicePriceKey = '';
          setVehicleProductTuneTypePrice(typeKey, 'Price Unavailable', false);
        });
      }));
    }

    function setGenericServicePrice(typeKey, title, amount, busy) {
      var option = typeEl.querySelector('option[value="' + typeKey + '"]');
      if (!option) return;
      option.textContent = title + ' — ' + amount;
      option.setAttribute('aria-busy', String(!!busy));
      if (serviceOnlyMode) {
        setVehicleProductTuneTypePrice(typeKey, amount, busy);
        option.textContent = title + ' — ' + amount;
        typeCards.forEach(function (card) {
          if (card.getAttribute('data-jrj-mini-type-card') !== typeKey) return;
          var label = card.querySelector('[data-jrj-service-title]');
          if (label) label.textContent = title;
        });
      }
    }

    function genericServicePartCents(item, resolved) {
      var cents = Number(resolved && resolved.priceCents);
      if (!resolved || !Number.isSafeInteger(Number(resolved.id)) || Number(resolved.id) <= 0 ||
          !resolved.variant || resolved.variant.available !== true ||
          !isFinite(cents) || cents <= 0 || (item.variantId && Number(resolved.id) !== Number(item.variantId)) ||
          (typeof resolved.variant.id !== 'undefined' && Number(resolved.variant.id) !== Number(resolved.id)) ||
          (typeof resolved.variant.price !== 'undefined' && (!isFinite(Number(resolved.variant.price)) || Number(resolved.variant.price) < 0))) {
        throw new Error('The mapped service price could not be verified.');
      }
      return cents;
    }

    function syncCustomTuneStartingPrice() {
      if (vehicleProductMode) return;
      var cart = window.JRJ_TUNE_CART;
      var year = String(yearEl.value);
      var make = String(makeEl.value);
      var model = String(modelEl.value);
      var engine = String(engineEl.value);
      var cam = customCamController ? customCamController.canonicalCam() : camEl.value;
      var camComplete = !customCamController || customCamController.isComplete();
      var baseConfig = config.baseTune || {};
      var key = JSON.stringify([year, make, model, engine, cam, camComplete, baseConfig.configured, baseConfig.variantId]);
      if (key === genericServicePriceKey) return;
      genericServicePriceKey = key;
      var token = ++customPriceLookupToken;
      var customTitle = 'Full Custom Remote Tune';
      var baseTitle = 'Base Tune — One Revision';
      var groups = customPriceCandidateGroups();
      var selection = engine ? cart.resolveVehicleSelection(year, make, model, engine) : null;
      var exactSelection = selection && !selection.ambiguous && selection.group && selection.baseProduct && (!remoteProductKey || selection.baseProductKey === remoteProductKey);
      var configuredBase = baseConfig.configured && baseConfig.variantId ? {
        variantId: baseConfig.variantId, handle: baseConfig.handle,
        title: baseConfig.title || baseTitle, priceCents: Number(baseConfig.priceCents) || 0
      } : null;

      if (engine && !exactSelection) {
        setGenericServicePrice('custom', customTitle, 'Price Unavailable', false);
        setGenericServicePrice('base', baseTitle, 'Price Unavailable', false);
        return;
      }

      if (!exactSelection || !cam || !camComplete) {
        if (cam && !camComplete) {
          setGenericServicePrice('custom', customTitle, 'Enter cam specifications', false);
          setGenericServicePrice('base', baseTitle, 'Enter cam specifications', false);
          return;
        }
        setGenericServicePrice('base', baseTitle, configuredBase ? 'Loading...' : 'Unavailable', !!configuredBase);
        setGenericServicePrice('custom', customTitle, 'Loading...', true);
        var generalStartingPrice = !groups.length;
        var baseStartingPromise = !configuredBase ? Promise.resolve() : cart.resolvePricedItem(configuredBase, engine)
          .then(function (resolved) {
            if (token !== customPriceLookupToken) return;
            setGenericServicePrice('base', baseTitle, cart.formatPrice(genericServicePartCents(configuredBase, resolved)), false);
          }).catch(function () {
            if (token !== customPriceLookupToken) return;
            genericServicePriceKey = '';
            setGenericServicePrice('base', baseTitle, 'Price Unavailable', false);
          });
        if (generalStartingPrice) setGenericServicePrice('custom', customTitle, startingPriceLabel('custom'), false);
        var customStartingPromise = generalStartingPrice ? Promise.resolve() : cart.resolveCustomTunePriceRange(groups, engine)
          .then(function (range) {
            if (token !== customPriceLookupToken) return;
            if (!range) throw new Error('No current custom tune starting price.');
            applyCustomPriceRange(range);
            var customOption = typeEl.querySelector('option[value="custom"]');
            if (customOption) customOption.setAttribute('aria-busy', 'false');
          }).catch(function () {
            if (token !== customPriceLookupToken) return;
            genericServicePriceKey = '';
            setGenericServicePrice('custom', customTitle, 'Price Unavailable', false);
          });
        return Promise.all([baseStartingPromise, customStartingPromise]);
      }

      // Use the same mapped tune and cam products as the package below.
      // Modifications, power adders and equipment remain separate line items.
      var customBase = cart.resolveMatchedBaseProductForGroup(selection.group, engine, cam, selection.baseProduct);
      var camPrices = {};
      return Promise.all(['custom', 'base'].map(function (typeKey) {
        var base = typeKey === 'custom' ? customBase : configuredBase;
        var title = typeKey === 'custom' ? (cart.isBasicDeleteProduct(base) ? base.title : customTitle) : baseTitle;
        if (!base || (!base.variantId && !base.handle)) {
          setGenericServicePrice(typeKey, title, 'Price Unavailable', false);
          return;
        }
        var camUpgrade = cart.resolveCamUpgradeForGroup(selection.group, engine, cam, base, year, make);
        var camKey = camUpgrade ? JSON.stringify(camUpgrade) : '';
        if (camUpgrade && !camPrices[camKey]) camPrices[camKey] = cart.resolvePricedItem(camUpgrade, engine);
        setGenericServicePrice(typeKey, title, 'Loading...', true);
        return Promise.all([
          cart.resolvePricedItem(base, engine),
          camUpgrade ? camPrices[camKey] : Promise.resolve(null)
        ]).then(function (parts) {
          if (token !== customPriceLookupToken) return;
          var amount = genericServicePartCents(base, parts[0]);
          if (camUpgrade) amount += genericServicePartCents(camUpgrade, parts[1]);
          setGenericServicePrice(typeKey, title, cart.formatPrice(amount), false);
        }).catch(function () {
          if (token !== customPriceLookupToken) return;
          genericServicePriceKey = '';
          setGenericServicePrice(typeKey, title, 'Price Unavailable', false);
        });
      }));
    }

    function getBaseProduct() {
      var selection = window.JRJ_TUNE_CART.resolveVehicleSelection(yearEl.value, makeEl.value, modelEl.value, engineEl.value);
      var key = selection && !selection.ambiguous ? selection.baseProductKey : '';
      var product = selection && !selection.ambiguous && (!remoteProductKey || selection.baseProductKey === remoteProductKey) ? selection.baseProduct : null;
      var genMatch = key.match(/^(gen[345]|hemi)/i);
      console.log('[JRJ Tune Builder - Mini] base product resolved:', {
        year: yearEl.value,
        make: makeEl.value,
        model: modelEl.value,
        generation: genMatch ? genMatch[1] : (key || 'unknown'),
        vehicleClass: key.indexOf('truck_suv') !== -1 ? 'Truck/SUV' : (key.indexOf('car') !== -1 ? 'Car' : 'unknown'),
        baseProductKey: key || null,
        variantId: product ? product.variantId : null
      });
      return product;
    }

    function updateCamOptions() {
      var group = engineEl.value ? findSelectedGroup(engineEl.value) : null;
      var list = group ? window.JRJ_TUNE_CART.camOptionsForGroup(group, engineEl.value) : [];
      var standardChoices = vehicleProductMode && fixedVehicle.variableEngine === true && fixedVehicle.groupId === 'gen3_gm_truck_suv'
        ? ['Stock Cam']
        : (vehicleProductMode
          ? ['Stock Cam / Delete Tune Only', 'VVT Delete Only']
          : ['Stock Cam / Delete Tune Only', 'VVT Delete Only']);
      setOptions(camEl, list.length ? window.JRJ_TUNE_CART.filterCamChoicesForGroup(group, engineEl.value, standardChoices.concat(list)) : [], 'Select cam...');
    }

    function updatePowertrainOptions() {
      var group = engineEl.value ? findSelectedGroup(engineEl.value) : null;
      if (!yearEl.value || !engineEl.value || !window.JRJ_POWERTRAIN_OPTIONS) {
        setOptions(transmissionEl, [], 'Select transmission...');
        setOptions(drivetrainEl, [], 'Select drivetrain...');
        transmissionEl.disabled = true;
        drivetrainEl.disabled = true;
        return;
      }
      var options = window.JRJ_POWERTRAIN_OPTIONS.getOptions({
        year: yearEl.value,
        make: makeEl.value,
        model: modelEl.value,
        engine: engineEl.value,
        groupId: group ? group.id : ''
      });
      var earlyL83Pickup = (makeEl.value === 'Chevrolet' && modelEl.value === 'Silverado 1500') ||
        (makeEl.value === 'GMC' && modelEl.value === 'Sierra 1500');
      if (vehicleProductMode && earlyL83Pickup && engineEl.value === '5.3L L83' && Number(yearEl.value) >= 2014 && Number(yearEl.value) <= 2015) {
        options.transmissions = (options.transmissions || []).filter(function (transmission) { return transmission !== '8L90'; });
      }
      if (vehicleProductMode && fixedVehicle.variableEngine === true && fixedVehicle.groupId === 'gen3_gm_truck_suv') {
        options.transmissions = (options.transmissions || []).filter(function (transmission) {
          return transmission === '4L60E' || transmission === "Not Listed / Don't Know";
        });
        options.drivetrains = (engineEl.value === '5.3L L33' ? ['4WD / 4x4'] : ['RWD / 4x2', '4WD / 4x4']).concat(["Not Listed / Don't Know"]);
      }
      setOptions(transmissionEl, options.transmissions || [], 'Select transmission...');
      setOptions(drivetrainEl, options.drivetrains || [], 'Select drivetrain...');
      transmissionEl.disabled = false;
      drivetrainEl.disabled = false;
    }

    function updateVehicleOptions(level) {
      if (vehicleProductMode) {
        if (level === 'year') {
          camEl.value = '';
          platformEl.value = '';
          if (fixedVehicle.variableEngine === true) engineEl.value = '';
        }
        if (fixedVehicle.variableEngine === true && (level === 'year' || level === 'engine')) {
          camEl.value = '';
          transmissionEl.value = '';
          drivetrainEl.value = '';
        }
        applyFixedVehicleSelection();
        var fixedGroup = engineEl.value ? findSelectedGroup(engineEl.value) : null;
        platformEl.value = fixedGroup ? fixedGroup.label + ' (' + fixedGroup.years + ')' : '';
        updateCamOptions();
        updatePowertrainOptions();
        syncCustomTuneStartingPrice();
        updateSummary();
        return;
      }
      if (level === 'year') {
        makeEl.value = '';
        modelEl.value = '';
        engineEl.value = '';
        camEl.value = '';
        platformEl.value = '';
      }
      if (level === 'make') {
        modelEl.value = '';
        engineEl.value = '';
        camEl.value = '';
        platformEl.value = '';
      }
      if (level === 'model') {
        engineEl.value = '';
        camEl.value = '';
        platformEl.value = '';
      }
      if (level === 'engine') camEl.value = '';

      if (yearEl.value && (!makeEl.value || level === 'year')) {
        setOptions(makeEl, remoteProductKey ? unique(remoteVehicleRows(yearEl.value).map(function (row) { return row.make; })) : window.JRJ_TUNE_CART.vehicleMakes(yearEl.value), 'Select make...');
      }

      if (makeEl.value && (!modelEl.value || level === 'make')) {
        setOptions(modelEl, remoteProductKey ? unique(remoteVehicleRows(yearEl.value).filter(function (row) { return row.make === makeEl.value; }).map(function (row) { return row.model; })) : window.JRJ_TUNE_CART.vehicleModels(yearEl.value, makeEl.value), 'Select model...');
      }

      if (modelEl.value && level !== 'engine') {
        setOptions(engineEl, remoteProductKey ? unique(remoteVehicleRows(yearEl.value).filter(function (row) { return row.make === makeEl.value && row.model === modelEl.value; }).map(function (row) { return row.engine; })) : window.JRJ_TUNE_CART.vehicleEngines(yearEl.value, makeEl.value, modelEl.value), 'Select engine...');
      }

      var selectedGroup = engineEl.value ? findSelectedGroup(engineEl.value) : null;
      platformEl.value = selectedGroup ? selectedGroup.label + ' (' + selectedGroup.years + ')' : '';
      updateCamOptions();
      updatePowertrainOptions();
      syncCustomTuneStartingPrice();
      updateSummary();
    }

    function formatMiniVehicleName(year, make, model) {
      var cleanModel = model || '';
      if (make && cleanModel.toLowerCase().indexOf(make.toLowerCase() + ' ') === 0) cleanModel = cleanModel.slice(make.length + 1);
      return [year, make, cleanModel].filter(Boolean).join(' ');
    }

    function isDownloadPath() {
      return typeEl.value === 'download';
    }

    function syncDownloadLimitUI() {
      var downloadable = isDownloadPath();
      var locked = !typeEl.value || downloadable;
      root.classList.toggle('is-download-path', downloadable);
      if (modOptionsWrap) modOptionsWrap.hidden = downloadable;
      if (downloadLimitWrap) downloadLimitWrap.hidden = !downloadable;
      if (mpvi4Upsell) mpvi4Upsell.hidden = downloadable;
      if (downloadable && mpvi4CheckEl) mpvi4CheckEl.checked = false;
      if (modLabelEl) modLabelEl.textContent = downloadable ? 'Downloadable File Limits' : (typeEl.value ? 'Modifications & Options' : 'Modifications & Options — Choose Tune Type First');
      Array.prototype.slice.call(addonWrap.querySelectorAll('input[type="checkbox"]')).forEach(function (input) {
        if (locked) input.checked = false;
        input.disabled = locked;
      });
      if (rushTurnaroundEl) {
        var base = typeEl.value === 'custom' ? getMatchedBaseProduct() : null;
        var rushEligible = typeEl.value === 'custom' && !!base && !isBasicDeleteProduct(base);
        if (!rushEligible) rushTurnaroundEl.checked = false;
        rushTurnaroundEl.disabled = !rushEligible;
        var rushLabel = rushTurnaroundEl.closest('label');
        if (rushLabel) rushLabel.hidden = !rushEligible;
      }
    }

    function getAddOns() {
      if (isDownloadPath()) return [];
      return Array.prototype.slice.call(addonWrap.querySelectorAll('input[type="checkbox"]:checked:not([data-jrj-mini-boost])')).filter(function (input) {
        if (input.value !== 'Rush Turnaround') return true;
        var base = typeEl.value === 'custom' ? getMatchedBaseProduct() : null;
        return !!base && !isBasicDeleteProduct(base);
      }).map(function (input) {
        return input.value;
      });
    }

    function getSelectedBoost() {
      if (isDownloadPath()) return '';
      var selected = boostInputs.filter(function (input) { return input.checked; })[0];
      return selected ? selected.value : '';
    }

    function updateShortTubeIncludedState() {
      var info = root.querySelector('[data-jrj-mini-short-tube]');
      var box = info ? info.querySelector('.jrj-mini-tune-builder__check-visual') : null;
      var longTube = addonWrap.querySelector('input[value="Long Tube Headers"]');
      if (!info || !box || !longTube) return;
      var included = !longTube.checked;
      info.setAttribute('aria-checked', included ? 'true' : 'false');
      box.classList.toggle('is-unchecked', !included);
      box.innerHTML = included ? '&#10003;' : '';
    }

    function resolveSelectedAddonItems() {
      if (typeEl.value === 'download') return Promise.resolve([]);
      var selection = window.JRJ_TUNE_CART.resolveVehicleSelection(yearEl.value, makeEl.value, modelEl.value, engineEl.value);
      var baseProductKey = selection && !selection.ambiguous ? selection.baseProductKey : '';
      return Promise.all(getAddOns().map(function (name) {
        if ((builderMap.includedDeletes || []).indexOf(name) !== -1) return null;
        return window.JRJ_TUNE_CART.resolveAddonProduct(name, baseProductKey, yearEl.value, makeEl.value, engineEl.value).then(function (resolved) {
          genericServicePartCents({}, resolved);
          return { name: name, resolved: resolved };
        });
      })).then(function (items) { return items.filter(Boolean); });
    }

    function vehicleSummary() {
      return formatMiniVehicleName(yearEl.value, makeEl.value, modelEl.value) + (engineEl.value ? ' - ' + engineEl.value : '');
    }

    function optionalBuilderValue(selector) {
      var element = root.querySelector(selector);
      return element ? String(typeof element.value === 'undefined' ? element.textContent : element.value).trim() : '';
    }

    function selectedTuneTypeLabel(base) {
      if (typeEl.value === 'base') return vehicleProductMode
        ? ((vehicleProductConfig.tuneTypeValues && vehicleProductConfig.tuneTypeValues.base) || 'Base Tune — One Revision')
        : 'Base Tune';
      if (typeEl.value === 'download') return 'Downloadable .HPT File';
      if (typeEl.value === 'custom') {
        var matched = base || getMatchedBaseProduct();
        if (isBasicDeleteProduct(matched)) return matched.title;
        return vehicleProductMode
          ? (vehicleProductServiceLabels('custom').title || 'Full Custom Remote Tune') : 'Full Custom Remote Tune';
      }
      return '';
    }

    function syncVehicleServiceChoices() {
      if (!serviceOnlyMode) return;
      if (vehicleProductMode) applyVehicleProductTuneTypePrices();
      typeCards.forEach(function (card) {
        var typeKey = card.getAttribute('data-jrj-mini-type-card');
        var selected = typeKey === typeEl.value;
        var labels = vehicleProductServiceLabels(typeKey);
        ['title', 'eyebrow', 'description'].forEach(function (key) {
          var node = card.querySelector('[data-jrj-service-' + key + ']');
          if (node && labels[key]) node.textContent = labels[key];
        });
        card.classList.toggle('is-selected', selected);
        card.setAttribute('aria-pressed', String(selected));
      });
    }

    function isStockDeleteCam() {
      return camEl.value === 'Stock Cam / Delete Tune Only' || camEl.value === 'Stock - No Cam Swap';
    }

    function isVvtDeleteOnlyCam() {
      return camEl.value === 'VVT Delete Only';
    }

    function getMatchedBaseProduct() {
      if (!typeEl.value) return null;
      if (serviceOnlyMode && typeEl.value !== 'custom' && typeEl.value !== 'base') return null;
      if (remoteProductKey && !findSelectedGroup(engineEl.value)) return null;
      if (vehicleProductMode && (typeEl.value === 'custom' || typeEl.value === 'base')) {
        return resolveVehicleProductVariant();
      }
      if (typeEl.value === 'base') {
        var baseConfig = config.baseTune || {};
        if (!baseConfig.configured || !baseConfig.variantId) return null;
        return {
          variantId: baseConfig.variantId,
          handle: baseConfig.handle,
          title: baseConfig.title || 'JRJ Base Tune — One Revision',
          priceCents: Number(baseConfig.priceCents) || 0
        };
      }
      if (typeEl.value === 'download') {
        var group = findSelectedGroup(engineEl.value);
        var camKey = window.JRJ_DOWNLOAD_CAM_MAP && window.JRJ_DOWNLOAD_CAM_MAP[camEl.value];
        if (!group || !camKey || typeof window.jrjFindExactInstantDownloadMatch !== 'function') return null;
        var exact = window.jrjFindExactInstantDownloadMatch({
          year: yearEl.value,
          engine: engineEl.value,
          groupId: group.id,
          model: modelEl.value
        }, camKey);
        if (!exact) return null;
        return {
          handle: exact.handle,
          title: exact.title || 'Exact Downloadable .HPT Tune File',
          priceCents: Number(exact.priceCents) || 9999,
          exactDownload: true
        };
      }
      var base = getBaseProduct();
      var group = findSelectedGroup(engineEl.value);
      return window.JRJ_TUNE_CART.resolveMatchedBaseProductForGroup(group, engineEl.value, customCamController ? customCamController.canonicalCam() : camEl.value, base);
    }

    function isBasicDeleteProduct(base) {
      return window.JRJ_TUNE_CART.isBasicDeleteProduct(base);
    }

    function getBasicDeleteSupport(base) {
      return window.JRJ_TUNE_CART.basicDeleteSupportLabel(base);
    }

    function getSelectedCamUpgrade() {
      if (typeEl.value === 'download') return null;
      var base = getMatchedBaseProduct();
      var group = findSelectedGroup(engineEl.value);
      return window.JRJ_TUNE_CART.resolveCamUpgradeForGroup(group, engineEl.value, customCamController ? customCamController.canonicalCam() : camEl.value, base, yearEl.value, makeEl.value);
    }

    function resolvePricedItem(item) {
      return window.JRJ_TUNE_CART.resolvePricedItem(item, engineEl.value).then(function (resolved) {
        genericServicePartCents(item, resolved);
        return validateVehicleBasicPrice(item, resolved);
      });
    }

    function displayComponentTitle(title) {
      if (title === 'Long Tube Headers') return 'Long-Tube Headers + Rear O2 Delete';
      if (title === 'Stock / Short-Tube Headers') return 'Stock / Short-Tube Headers';
      return title;
    }

    function setPriceBreakdown(lines, totalCents, token) {
      if (token !== priceLookupToken) return;
      summaryPriceReady = true;
      summaryTotalCents = totalCents;
      var wrap = resultEl.querySelector('[data-jrj-mini-price-breakdown]');
      var amount = resultEl.querySelector('.jrj-mini-tune-builder__result-amount');
      if (wrap) {
        wrap.innerHTML = lines.map(function (line) {
          var className = 'jrj-mini-tune-builder__price-line' + (line.kind ? ' is-' + line.kind : '');
          return '<div class="' + className + '"><span>' + escapeHtml(displayComponentTitle(line.title)) + '</span><b>' + escapeHtml(line.value) + '</b></div>';
        }).join('');
      }
      if (amount) amount.textContent = window.JRJ_TUNE_CART.formatPrice(totalCents) || 'Price Unavailable';
      renderBuildConfirmation(getMatchedBaseProduct());
    }

    function updateTunePrice(base, token) {
      if (!base || (!base.handle && !base.variantId)) {
        var missing = resultEl.querySelector('.jrj-mini-tune-builder__result-amount');
        if (missing) missing.textContent = 'Price Unavailable';
        return;
      }
      var selectedType = typeEl.value;
      var downloadPath = selectedType === 'download';
      var camUpgrade = getSelectedCamUpgrade();
      var boostName = getSelectedBoost();
      var selectedNames = getAddOns();
      var includeMpvi4 = !downloadPath && mpvi4CheckEl && mpvi4CheckEl.checked && !mpvi4AlreadyInCart;
      // These lookups are independent. Start them together from one selection
      // snapshot instead of waiting for the main tune before requesting add-ons.
      return Promise.resolve().then(function () {
        if (token !== priceLookupToken) return;
        var basePricePromise = resolvePricedItem(base);
        var camPromise = camUpgrade ? resolvePricedItem(camUpgrade) : Promise.resolve(null);
        var addonPricePromise = resolveSelectedAddonItems();
        var boostPricePromise = !downloadPath && boostName
          ? window.JRJ_TUNE_CART.resolveForcedInductionAddon(boostName).catch(function (err) {
              console.warn('Mini Tune Builder blower add-on price unavailable:', boostName, err);
              return null;
            })
          : Promise.resolve(null);
        var mpvi4PricePromise = includeMpvi4
          ? resolvePricedItem({
              variantId: MPVI4_VARIANT_ID,
              title: 'HP Tuners MPVI4',
              priceCents: MPVI4_PRICE_CENTS
            })
          : Promise.resolve(null);

        return Promise.all([basePricePromise, camPromise, addonPricePromise, boostPricePromise, mpvi4PricePromise]).then(function (priceParts) {
          if (token !== priceLookupToken) return;
          var baseResolved = priceParts[0];
          var baseCents = genericServicePartCents(base, baseResolved);
          if (downloadPath) markDownloadMatchFound(base, token);
          var camResolved = priceParts[1];
          var addonVariants = priceParts[2];
          var boostResolved = priceParts[3];
          var mpvi4Resolved = priceParts[4];
          var lines = [];
          var totalCents = baseCents;
          lines.push({ title: base.title || baseResolved.title || 'Tune Package', value: window.JRJ_TUNE_CART.formatPrice(baseCents) });

          if (camUpgrade) {
            var camCents = genericServicePartCents(camUpgrade, camResolved);
            totalCents += camCents;
            lines.push({ title: camUpgrade.title || camResolved.title || 'Cam Tune Upgrade', value: window.JRJ_TUNE_CART.formatPrice(camCents) });
          }

          addonVariants.forEach(function (item) {
            var cents = genericServicePartCents({}, item && item.resolved);
            totalCents += cents;
            lines.push({ title: item.name, value: window.JRJ_TUNE_CART.formatPrice(cents) });
          });

          if (!downloadPath && boostName) {
            var boostCents = genericServicePartCents({}, boostResolved);
            totalCents += boostCents;
            lines.push({ title: boostName + ' Tune Add-On', value: window.JRJ_TUNE_CART.formatPrice(boostCents) });
          }

          if (includeMpvi4) {
            var mpvi4Cents = genericServicePartCents({ variantId: MPVI4_VARIANT_ID }, mpvi4Resolved);
            totalCents += mpvi4Cents;
            lines.push({ title: 'HP Tuners MPVI4', value: window.JRJ_TUNE_CART.formatPrice(mpvi4Cents) });
          }

          var pricedNames = addonVariants.map(function (item) { return item.name; });
          if (!downloadPath && selectedNames.indexOf('Long Tube Headers') === -1) {
            lines.push({ title: 'Stock / Short-Tube Headers', value: 'Included', kind: 'included' });
          }
          selectedNames.filter(function (name) { return pricedNames.indexOf(name) === -1; }).forEach(function (name) {
            lines.push({ title: name, value: downloadPath ? 'Recorded' : 'Included', kind: 'included' });
          });

          var discountApplies = window.JRJ_TUNE_CART.activeCurrency() === 'USD' && window.JRJ_TUNE_CART.bundleDiscountApplies({
            tuneType: selectedType,
            aspiration: boostName ? 'supercharged' : 'na',
            camUpgrade: camUpgrade
          });
          if (discountApplies) {
            var discountCents = Math.round(Number(window.JRJ_TUNE_CART.CAM_BLOWER_BUNDLE_DISCOUNT || 0) * 100);
            totalCents = Math.max(0, totalCents - discountCents);
            lines.push({ title: 'Cam + Blower Bundle Discount', value: '-' + window.JRJ_TUNE_CART.formatPrice(discountCents), kind: 'discount' });
          }

          setPriceBreakdown(lines, totalCents, token);
        });
      }).catch(function (err) {
        if (token !== priceLookupToken) return;
        console.error(err);
        if (downloadPath) markDownloadMatchUnavailable(base, token);
        var fallback = resultEl.querySelector('.jrj-mini-tune-builder__result-amount');
        if (fallback) fallback.textContent = 'Price Unavailable';
        renderBuildConfirmation(null);
      });
    }

    function lineItemProperties(base, linkedTuneKey) {
      if (typeEl.value === 'download') return {};
      var addOns = getAddOns();
      var boostName = getSelectedBoost();
      var props = window.JRJ_TUNE_CART.buildPortalPurchaseProperties({
        year: yearEl.value,
        make: makeEl.value,
        model: modelEl.value,
        engine: engineEl.value,
        transmission: optionalBuilderValue('[data-jrj-mini-transmission]'),
        drivetrain: optionalBuilderValue('[data-jrj-mini-drivetrain]'),
        cam: customCamController ? customCamController.canonicalCam() : camEl.value,
        tuneType: selectedTuneTypeLabel(base),
        mods: addOns,
        lsaBlower: boostName === 'LSA Blower',
        hellcatBlower: boostName === 'Hellcat Blower',
        vin: optionalBuilderValue('[data-jrj-mini-vin]'),
        vinDetails: optionalBuilderValue('[data-jrj-mini-vin-details]'),
        downloadable: typeEl.value === 'download'
      });
      window.JRJ_TUNE_CART.markPrimaryTuneProperties(props, linkedTuneKey);
      if (base && base.title) props['_Matched Product'] = base.title;
      props['_JRJ Builder Version'] = 'Mini Tune Builder';
      if (typeEl.value === 'base') {
        props['_Revision Limit'] = '1';
        props['_JRJ Project Type'] = 'base_tune';
      } else {
        props['_JRJ Project Type'] = 'custom_remote_tune';
      }
      return props;
    }

    function linkedLineProperties(linkedTuneKey) {
      return typeEl.value === 'download' ? {} : window.JRJ_TUNE_CART.buildLinkedTuneProperties(linkedTuneKey);
    }

    function setMpvi4Status(message, isError) {
      if (!mpvi4StatusEl) return;
      mpvi4StatusEl.textContent = message || '';
      mpvi4StatusEl.classList.toggle('jrj-mini-mpvi4-upsell__message--error', !!isError);
    }

    function cartHasMpvi4() {
      return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('Could not check cart for MPVI4');
          return res.json();
        })
        .then(function (cart) {
          return !!(cart && cart.items || []).some(function (item) {
            return Number(item.variant_id) === MPVI4_VARIANT_ID;
          });
        });
    }

    function appendMpvi4IfNeeded(items, linkedTuneKey) {
      if (!mpvi4CheckEl || !mpvi4CheckEl.checked) {
        setMpvi4Status('', false);
        return Promise.resolve(items);
      }

      return cartHasMpvi4().then(function (alreadyInCart) {
        mpvi4AlreadyInCart = alreadyInCart;
        if (alreadyInCart) {
          setMpvi4Status('MPVI4 already in cart', false);
          return items;
        }

        items.push({
          id: MPVI4_VARIANT_ID,
          quantity: 1,
          properties: linkedLineProperties(linkedTuneKey)
        });
        setMpvi4Status('MPVI4 will be added with your tune.', false);
        return items;
      }).catch(function (err) {
        setMpvi4Status('We could not check the MPVI4 cart status. Please try again.', true);
        throw err;
      });
    }

    function refreshMpvi4Status() {
      if (!mpvi4CheckEl || !mpvi4StatusEl) return;
      cartHasMpvi4().then(function (alreadyInCart) {
        mpvi4AlreadyInCart = alreadyInCart;
        if (mpvi4CheckEl.checked) {
          setMpvi4Status(alreadyInCart ? 'MPVI4 already in cart — not added twice.' : 'MPVI4 will be added with your tune.', false);
        } else {
          setMpvi4Status(alreadyInCart ? 'MPVI4 already in cart' : '', false);
        }
        updateSummary();
      }).catch(function () {
        mpvi4AlreadyInCart = false;
        setMpvi4Status('', false);
        updateSummary();
      });
    }

    function validateSelections() {
      if (!yearEl.value || !makeEl.value || !modelEl.value || !engineEl.value || !camEl.value) {
        alert('Please select year, make, model, engine, and cam selection first.');
        return false;
      }
      if (!transmissionEl.value || !drivetrainEl.value) {
        alert("Please select the transmission and drivetrain. Choose Not Listed / Don't Know if you are unsure.");
        return false;
      }
      if (customCamController && !customCamController.isComplete()) {
        alert('Enter Intake Duration at .050, Exhaust Duration at .050, and LSA from the cam card.');
        return false;
      }
      if (!typeEl.value) {
        alert(vehicleProductMode
          ? 'Please choose Full Custom Remote Tune or Base Tune — One Revision.'
          : 'Please choose Full Custom, Base, or Downloadable .HPT.');
        return false;
      }
      if (!vehicleProductMode && typeEl.value === 'base' && (!config.baseTune || !config.baseTune.configured || !config.baseTune.variantId)) {
        alert('The $169.99 USD Base Tune product must be created and assigned before this path can be purchased. No placeholder product will be added to your cart.');
        return false;
      }
      var base = getMatchedBaseProduct();
      if (!base || (typeEl.value === 'download' && downloadMatchState !== 'found')) {
        alert(typeEl.value === 'download'
          ? 'We do not have an exact downloadable .HPT file available for this vehicle, engine, and camshaft. Choose Base Tune or Full Custom Remote Tune; no closest-file substitution will be made.'
          : 'We could not resolve the correct tune product for this combination. Please contact support for help.');
        if (typeEl.value === 'download' && downloadMissingWrap) downloadMissingWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      if (!base.handle && !base.variantId) {
        console.warn('Mini Tune Builder product has no Shopify handle or variant ID:', base.title);
        alert('That tune product still needs a Shopify product mapping. Please text us at 910-239-7598.');
        return false;
      }
      return true;
    }

    function restoreBuilderAfterHistory(event) {
      if (!event.persisted) return;
      // A cached page keeps the controls disabled at the moment it left for
      // the cart. Do not unlock an unfinished request or submit anything again.
      if (cartRequestPending) {
        restoreAfterCartRequest = true;
        return;
      }
      restoreAfterCartRequest = false;
      setVehicleProductControlsBusy(false);
      cartBtn.removeAttribute('aria-busy');
      cartBtn.style.pointerEvents = '';
      if (typeof window.JRJ_TUNE_CART.invalidateCatalogCache === 'function') window.JRJ_TUNE_CART.invalidateCatalogCache();
      vehicleServicePriceKey = '';
      genericServicePriceKey = '';
      updateSummary();
      refreshMpvi4Status();
    }

    function addMiniTuneToCart(event) {
      if (event) event.preventDefault();
      if (cartBtn.getAttribute('aria-busy') === 'true') return;
      if (!validateSelections()) return;
      var base = getMatchedBaseProduct();
      if (typeEl.value === 'download') {
        if (vehicleProductMode) {
          alert('This vehicle-specific product offers Full Custom Remote Tune or Base Tune — One Revision only.');
          return;
        }
        window.location.assign('/products/' + base.handle);
        return;
      }
      var selectionFingerprint = vehicleProductSelectionFingerprint(base);
      var oldText = cartBtn.textContent;
      cartRequestPending = true;
      setVehicleProductControlsBusy(true);
      cartBtn.setAttribute('aria-busy', 'true');
      cartBtn.textContent = 'Adding To Cart...';
      cartBtn.style.pointerEvents = 'none';

      resolvePricedItem(base).then(function (resolved) {
        if (!resolved || !resolved.id || (resolved.variant && resolved.variant.available === false)) {
          throw new Error('The exact tune variant is not available for sale in Shopify.');
        }
        if (selectionFingerprint !== vehicleProductSelectionFingerprint(base)) {
          throw new Error('The vehicle configuration changed while the exact variant was being verified.');
        }
        var selectedAddonsPromise = resolveSelectedAddonItems();
        var camUpgrade = getSelectedCamUpgrade();
        var boostName = getSelectedBoost();
        var linkedTuneKey = window.JRJ_TUNE_CART.createLinkedTuneKey();
        var items = [{ id: resolved.id, quantity: 1, properties: lineItemProperties(base, linkedTuneKey) }];
        var camPromise = camUpgrade ? resolvePricedItem(camUpgrade).then(function (camResolved) {
          items.push({
            id: camResolved.id,
            quantity: 1,
            properties: linkedLineProperties(linkedTuneKey)
          });
        }) : Promise.resolve();

        var boostPromise = typeEl.value !== 'download' && boostName
          ? window.JRJ_TUNE_CART.resolveForcedInductionAddon(boostName).then(function (boostResolved) {
              genericServicePartCents({}, boostResolved);
              items.push({
                id: boostResolved.id,
                quantity: 1,
                properties: linkedLineProperties(linkedTuneKey)
              });
            })
          : Promise.resolve();

        return Promise.all([camPromise, boostPromise, selectedAddonsPromise]).then(function (parts) {
          var selectedAddons = parts[2] || [];
          selectedAddons.forEach(function (addon) {
            if (!addon.resolved || !addon.resolved.id) return;
            items.push({
              id: addon.resolved.id,
              quantity: 1,
              properties: linkedLineProperties(linkedTuneKey)
            });
          });
          return appendMpvi4IfNeeded(items, linkedTuneKey).then(function (cartItems) {
            if (selectionFingerprint !== vehicleProductSelectionFingerprint(base)) {
              throw new Error('The vehicle configuration changed before the cart request was submitted.');
            }
            return window.JRJ_TUNE_CART.addItemsToCart(cartItems);
          });
        });
      }).then(function () {
        cartRequestPending = false;
        if (restoreAfterCartRequest) restoreBuilderAfterHistory({ persisted: true });
      }).catch(function (err) {
        cartRequestPending = false;
        console.error(err);
        alert('We could not add that tune package automatically right now. If MPVI4 was selected, your tune selections are still here so you can retry. Please try again or text us at 910-239-7598.');
        setVehicleProductControlsBusy(false);
        cartBtn.removeAttribute('aria-busy');
        cartBtn.textContent = oldText;
        cartBtn.style.pointerEvents = '';
        if (restoreAfterCartRequest) restoreBuilderAfterHistory({ persisted: true });
      });
    }

    function updateSummary() {
      if (cartBtn.getAttribute('aria-busy') === 'true') return;
      if (customCamController) customCamController.refresh(false);
      summaryPriceReady = false;
      summaryTotalCents = 0;
      syncDownloadLimitUI();
      syncVehicleServiceChoices();
      syncCustomTuneStartingPrice();
      updateShortTubeIncludedState();
      var vehicle = formatMiniVehicleName(yearEl.value, makeEl.value, modelEl.value);
      var hasCompleteSelection = !!(yearEl.value && makeEl.value && modelEl.value && engineEl.value && camEl.value && transmissionEl.value && drivetrainEl.value && (!customCamController || customCamController.isComplete()) && typeEl.value);
      var base = hasCompleteSelection ? getMatchedBaseProduct() : null;
      beginDownloadAvailabilityCheck(base);
      var addOns = getAddOns();
      var boostName = getSelectedBoost();
      var camUpgrade = hasCompleteSelection ? getSelectedCamUpgrade() : null;
      var token = ++priceLookupToken;
      var copyLines = [];
      var priceText = base ? 'Loading...' : 'Select Vehicle';
      var pathLabel = typeEl.value === 'base' ? 'Base Tune — One Revision' : (typeEl.value === 'download' ? 'Downloadable .HPT — Compare & Copy' : (typeEl.value === 'custom' ? 'Custom Remote Tune' : 'Choose Tune Type'));
      if (typeEl.value === 'custom') pathLabel = selectedTuneTypeLabel(base);

      cartBtn.textContent = typeEl.value === 'base'
        ? 'Add Base Tune To Cart'
        : (typeEl.value === 'custom' ? 'Add Custom Tune To Cart' : 'Choose Tune Type');
      if (vehicleProductMode && typeEl.value === 'custom') cartBtn.textContent = vehicleProductServiceLabels('custom').button || cartBtn.textContent;
      if (typeEl.value === 'custom' && isBasicDeleteProduct(base)) cartBtn.textContent = 'Add Basic Tune To Cart';
      updateDownloadCartButtonText();

      if (base) {
        copyLines.push('<strong>Tune path:</strong> ' + escapeHtml(pathLabel));
        copyLines.push('<strong>Matched tune:</strong> ' + escapeHtml(base.title));
        if (isBasicDeleteProduct(base)) {
          copyLines.push('<strong>Tune Type:</strong> ' + escapeHtml(selectedTuneTypeLabel(base)));
          copyLines.push('<strong>Supported:</strong> ' + escapeHtml(getBasicDeleteSupport(base)));
          copyLines.push('No custom cam tuning included.');
        } else {
          copyLines.push('<strong>Selected cam:</strong> ' + escapeHtml(customCamController ? customCamController.canonicalCam() : camEl.value));
          if (camUpgrade) copyLines.push('<strong>Cam upgrade:</strong> ' + escapeHtml(camUpgrade.title));
        }
        if (isDownloadPath()) {
          copyLines.push('<strong>Modification support:</strong> Not included');
          copyLines.push('This file covers the selected supported cam or delete calibration only.');
        } else {
          if (addOns.length) copyLines.push('<strong>Add-ons:</strong> ' + escapeHtml(addOns.join(', ')));
          else copyLines.push('<strong>Add-ons:</strong> None');
          copyLines.push('<strong>Blower:</strong> ' + escapeHtml(boostName || 'None / Naturally Aspirated'));
        }
      } else {
        copyLines.push('<strong>Tune path:</strong> ' + escapeHtml(pathLabel));
        if (vehicleProductMode && (typeEl.value === 'custom' || typeEl.value === 'base') && vehicleVariantError) {
          copyLines.push(escapeHtml(vehicleVariantError));
          priceText = 'Exact Variant Unavailable';
        } else if (typeEl.value === 'base' && (!config.baseTune || !config.baseTune.configured)) {
          copyLines.push('The real $169.99 USD Base Tune Shopify product still needs to be assigned.');
          priceText = '$169.99 USD — Setup Required';
        } else if (typeEl.value === 'download' && hasCompleteSelection) {
          copyLines.push('No exact downloadable match. Choose Base or Custom; no closest file will be substituted.');
          priceText = 'No Exact Match';
        } else {
          copyLines.push('Choose the vehicle and camshaft, select Tune Type, then add supported modifications.');
        }
      }

      var pricePlaceholder = base
        ? 'Loading live Shopify prices'
        : (typeEl.value === 'download' && hasCompleteSelection ? 'No exact downloadable product available' : 'Complete your vehicle selections');
      resultEl.innerHTML = '<div class="jrj-mini-tune-builder__result-layout"><div class="jrj-mini-tune-builder__result-match"><div class="jrj-mini-tune-builder__result-title">Your Tune Match</div><div class="jrj-mini-tune-builder__result-copy">' + copyLines.join('<br>') + '</div></div><div class="jrj-mini-tune-builder__result-price" aria-live="polite"><div class="jrj-mini-tune-builder__result-title">Price Breakdown</div><div class="jrj-mini-tune-builder__price-lines" data-jrj-mini-price-breakdown><div class="jrj-mini-tune-builder__price-line is-placeholder"><span>' + pricePlaceholder + '</span><b>' + (base ? '&hellip;' : '&mdash;') + '</b></div></div><div class="jrj-mini-tune-builder__price-total"><span>Total</span><div class="jrj-mini-tune-builder__result-amount">' + priceText + '</div></div></div></div>';
      renderBuildConfirmation(base);
      if (base) updateTunePrice(base, token);

      var sms = 'Hi, I want help finding my tune file.' +
        (vehicle ? '\nVehicle: ' + vehicle : '') +
        (engineEl.value ? '\nEngine: ' + engineEl.value : '') +
        (camEl.value ? '\nCam Selection: ' + (customCamController ? customCamController.canonicalCam() : camEl.value) : '') +
        (boostName ? '\nBlower: ' + boostName : '') +
        '\nTune Path: ' + pathLabel +
        (platformEl.value ? '\nMatched platform: ' + platformEl.value : '') +
        (base ? '\nShopify product: ' + base.title : '') +
        (camUpgrade ? '\nCam upgrade: ' + camUpgrade.title : '') +
        (addOns.length ? '\nAdd-Ons: ' + addOns.join(', ') : '');
      if (textBtn) textBtn.href = 'sms:+19102397598?body=' + encodeURIComponent(sms);
    }

    yearEl.addEventListener('change', function () { updateVehicleOptions('year'); });
    makeEl.addEventListener('change', function () { updateVehicleOptions('make'); });
    modelEl.addEventListener('change', function () { updateVehicleOptions('model'); });
    engineEl.addEventListener('change', function () { updateVehicleOptions('engine'); });
    camEl.addEventListener('change', function () {
      if (customCamController) customCamController.refresh(false);

      updateSummary();
    });
    typeEl.addEventListener('change', function () { updateSummary(); });
    typeCards.forEach(function (card) {
      card.addEventListener('click', function () {
        var requestedType = card.getAttribute('data-jrj-mini-type-card');
        if (requestedType !== 'custom' && requestedType !== 'base') return;
        typeEl.value = requestedType;
        typeEl.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    transmissionEl.addEventListener('change', function () { updateSummary(); });
    drivetrainEl.addEventListener('change', function () { updateSummary(); });
    downloadFallbackButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var requestedPath = button.getAttribute('data-jrj-mini-fallback-path');
        if (requestedPath !== 'base' && requestedPath !== 'custom') return;
        typeEl.value = requestedPath;
        typeEl.dispatchEvent(new Event('change', { bubbles: true }));
        var modStage = root.querySelector('[data-jrj-mini-mod-stage]');
        if (modStage) modStage.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    boostInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) {
          boostInputs.forEach(function (other) {
            if (other !== input) other.checked = false;
          });
        }
        updateSummary();
      });
    });
    Array.prototype.slice.call(addonWrap.querySelectorAll('input[type="checkbox"]:not([data-jrj-mini-boost])')).forEach(function (input) {
      input.addEventListener('change', function () {
        updateShortTubeIncludedState();
        updateSummary();
      });
    });
    cartBtn.addEventListener('click', addMiniTuneToCart);
    window.addEventListener('pageshow', restoreBuilderAfterHistory);
    if (mpvi4CheckEl) {
      mpvi4CheckEl.addEventListener('change', refreshMpvi4Status);
      refreshMpvi4Status();
    }
    if (window.JRJ_CUSTOM_CAM_SPECS) {
      customCamController = window.JRJ_CUSTOM_CAM_SPECS.create(root, {
        camInput: camEl,
        engineHint: function () { return engineEl.value; },
        resolveUpgrade: function (canonicalCam) {
          var group = findSelectedGroup(engineEl.value);
          var base = getBaseProduct();
          return window.JRJ_TUNE_CART.resolveCamUpgradeForGroup(group, engineEl.value, canonicalCam, base, yearEl.value, makeEl.value);
        },
        onChange: function () {
          updateSummary();
        }
      });
    }
    var availableYears = vehicleProductMode ? fixedVehicleYears() : allYears(remoteProductKey ? { groups: remoteCandidateGroups } : builderMap);
    if (remoteProductKey) availableYears = availableYears.filter(function (year) { return remoteVehicleRows(year).length > 0; });
    setOptions(yearEl, availableYears, 'Select year...');
    if (vehicleProductMode) applyFixedVehicleSelection();
    updateCamOptions();
    updatePowertrainOptions();
    syncCustomTuneStartingPrice();
    updateShortTubeIncludedState();
    updateSummary();
    initializeVehicleProductVariantFromUrl();

    root.addEventListener('change', function (event) {
      cartBtn.disabled = true;
    }, true);
    setBuilderStartupReady(root);
  }

  function init() {
    document.addEventListener('click', function (event) {
      var productsLink = event.target.closest && event.target.closest('[data-jrj-scroll-products]');
      if (!productsLink) return;

      var target = document.getElementById('all-tune-files') ||
        document.querySelector('#hemi-cam-tune-products, [id$="tune-products"], .jrj-dod-product, .jrj-seo-actions, .product-form__buttons, product-form');

      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    Array.prototype.slice.call(document.querySelectorAll('[data-jrj-mini-tune-builder]')).forEach(function (root) {
      try {
        initBuilder(root);
      } catch (error) {
        setBuilderStartupFailure(root, error);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
